export default __webpack_public_path__ + "media/images/gallery/29-e55cd41e26c531f628bdf29ae680312d.jpg";